import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';

import { ErrorBoundary } from './components/ErrorBoundary';
import { MEDIA_MANAGER_ROUTES } from './constants/MediaManagerRoutes';
import { RouteNotFoundException } from './RouteExceptions/RouteNotFoundException';
import { RouterManager } from './RouterManager/RouterManager';
import { MainRouteEnum } from './types';

export const routes: RouteObject[] = [
  {
    id: MainRouteEnum.MAIN,
    ErrorBoundary,
    hasErrorBoundary: true,
    children: [
      {
        path: '',
        element: <Navigate to={'app'} />,
      },
      MEDIA_MANAGER_ROUTES,
      {
        path: '*',
        Component: () => {
          throw new RouteNotFoundException();
        },
      },
    ],
  },
];

export const router = createBrowserRouter(routes);

export const routerManager = new RouterManager(router);
